import React from 'react';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import WithIndicator from 'root/components/withIndicator';
import t from 'common/i18n';
import SvgIcon from 'root/components/SvgIcon';
import LinkButton from 'root/components/LinkButton/LinkButton';
import SVG_ICONS from '~/assets/icons/icons';

const FiltersBox = styled.div`
  display: flex;
  background: ${globalTheme.palette.surface};
  flex-direction: column;
  height: 535px;
`;

const FiltersHeader = styled.div`
  padding: 0px ${globalTheme.spacing.xs};
  display: flex;
  justify-content: space-between;
  height: 51px;
  border-bottom: 1px solid ${globalTheme.palette.secondary};
`;

const ToggleButton = styled.div`
  display: flex;
  align-items: center;
  > label {
    padding-left: ${globalTheme.spacing.xxs};
  }
`;
const FiltersContainer = styled.div`
  height: 466px;
  overflow: auto;
`;

export default ({ handleSearch, clearSearchFilters, areFiltersSet, isFiltersPanelOpen, source, filtersMap, filterSet }) => {
  return (
    <FiltersBox data-test={isFiltersPanelOpen ? 'filters-panel-open' : null}>
      <FiltersContainer data-test={'filters-panel'}>
        <FiltersHeader>
          <ToggleButton>
            <WithIndicator showIndicator={areFiltersSet} className="flex">
              <SvgIcon size="sm" path={SVG_ICONS.SLIDERS} colorName="menu-icons" />
            </WithIndicator>
            <label>{t(`${source}.filters.toggle_filters_button`)}</label>
          </ToggleButton>
          {areFiltersSet && (
            <LinkButton dataTest={`${source}-filters-clear-button`} text={t(`${source}.filters.clear`)} fontSize={12} onClick={clearSearchFilters} />
          )}
        </FiltersHeader>
        {filtersMap.map(
          (item) => filterSet.includes(item.name) && <item.component key={item.name} handleSearch={handleSearch} source={source} {...item.params} />
        )}
      </FiltersContainer>
    </FiltersBox>
  );
};
